// Sugere correção para typos óbvios em provedores de email comuns.
// Funciona 100% offline — sem chamadas externas, sem dados saindo do browser.

const POPULAR_DOMAINS = [
    'gmail.com',
    'hotmail.com',
    'hotmail.com.br',
    'outlook.com',
    'outlook.com.br',
    'yahoo.com',
    'yahoo.com.br',
    'icloud.com',
    'live.com',
    'live.com.br',
    'msn.com',
    'me.com',
    'protonmail.com',
    'proton.me',
    'aol.com',
    'bol.com.br',
    'uol.com.br',
    'terra.com.br',
    'ig.com.br',
    'globo.com',
    'globomail.com',
    'r7.com',
    'oi.com.br',
    'edify.com.br',
];

const POPULAR_TLDS = [
    'com',
    'com.br',
    'net',
    'net.br',
    'org',
    'org.br',
    'br',
    'edu',
    'edu.br',
    'gov.br',
    'io',
];

function levenshtein(a, b) {
    if (a === b) return 0;
    const m = a.length;
    const n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;

    let prev = new Array(n + 1);
    let curr = new Array(n + 1);
    for (let j = 0; j <= n; j++) prev[j] = j;

    for (let i = 1; i <= m; i++) {
        curr[0] = i;
        for (let j = 1; j <= n; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            curr[j] = Math.min(
                curr[j - 1] + 1,
                prev[j] + 1,
                prev[j - 1] + cost
            );
        }
        [prev, curr] = [curr, prev];
    }
    return prev[n];
}

function findClosest(target, candidates, ratio) {
    let best = null;
    let bestDist = Infinity;
    for (const candidate of candidates) {
        const dist = levenshtein(target, candidate);
        if (dist === 0) return { match: candidate, dist: 0 };
        const threshold = Math.max(1, Math.floor(candidate.length * ratio));
        if (dist <= threshold && dist < bestDist) {
            bestDist = dist;
            best = candidate;
        }
    }
    return best ? { match: best, dist: bestDist } : null;
}

// Retorna { suggestion, suggestedDomain } se houver typo provável, senão null.
export function suggestEmailFix(email) {
    if (!email || typeof email !== 'string') return null;

    const trimmed = email.trim().toLowerCase();
    const atIdx = trimmed.lastIndexOf('@');
    if (atIdx < 1 || atIdx === trimmed.length - 1) return null;

    const local = trimmed.slice(0, atIdx);
    const domain = trimmed.slice(atIdx + 1);

    if (POPULAR_DOMAINS.includes(domain)) return null;

    const domainMatch = findClosest(domain, POPULAR_DOMAINS, 0.3);
    if (domainMatch && domainMatch.dist > 0) {
        return {
            suggestion: `${local}@${domainMatch.match}`,
            suggestedDomain: domainMatch.match,
        };
    }

    const firstDot = domain.indexOf('.');
    if (firstDot > 0) {
        const tld = domain.slice(firstDot + 1);
        const root = domain.slice(0, firstDot);

        if (!POPULAR_TLDS.includes(tld)) {
            const tldMatch = findClosest(tld, POPULAR_TLDS, 0.4);
            if (tldMatch && tldMatch.dist > 0) {
                const fixedDomain = `${root}.${tldMatch.match}`;
                return {
                    suggestion: `${local}@${fixedDomain}`,
                    suggestedDomain: fixedDomain,
                };
            }
        }
    }

    return null;
}

// Anexa o validador a um <input> e a um <div> de hint. Bloqueia submissão até
// o usuário aceitar a sugestão ou descartá-la explicitamente (clicando em "não").
export function attachEmailSuggestion(inputEl, hintEl) {
    if (!inputEl || !hintEl) return { isBlocked: () => false };

    let dismissedFor = null;
    let activeSuggestion = null;

    const $input = $(inputEl);
    const $hint = $(hintEl);

    const clear = () => {
        $hint.empty().hide();
        activeSuggestion = null;
    };

    const render = (suggestion) => {
        activeSuggestion = suggestion;
        $hint
            .empty()
            .append(
                $('<span>').text('Você quis dizer '),
                $('<button type="button" class="btn btn-link p-0 m-0 align-baseline">')
                    .css({ 'font-weight': 'bold', 'text-decoration': 'underline' })
                    .text(suggestion.suggestion)
                    .on('click', (e) => {
                        e.preventDefault();
                        $input.val(suggestion.suggestion).trigger('change');
                        dismissedFor = suggestion.suggestion.toLowerCase();
                        clear();
                    }),
                $('<span>').text(' ? '),
                $('<button type="button" class="btn btn-link p-0 m-0 align-baseline text-muted">')
                    .css({ 'font-size': '0.85em' })
                    .text('não, manter')
                    .on('click', (e) => {
                        e.preventDefault();
                        const current = ($input.val() || '').trim().toLowerCase();
                        dismissedFor = current;
                        clear();
                    })
            )
            .show();
    };

    const evaluate = () => {
        const value = ($input.val() || '').trim().toLowerCase();
        if (!value) { clear(); return; }
        if (dismissedFor === value) { clear(); return; }
        const result = suggestEmailFix(value);
        if (result) render(result);
        else clear();
    };

    $input.on('blur change', evaluate);
    $input.on('input', () => {
        if (activeSuggestion) clear();
    });

    return {
        isBlocked: () => activeSuggestion !== null,
        getSuggestion: () => activeSuggestion,
        focusInput: () => $input.trigger('focus'),
    };
}

export default { suggestEmailFix, attachEmailSuggestion };
